export default __webpack_public_path__ + "static/media/Calendar_16.1bb9bf1a.svg";